// P33 (2026-10-12): after a deploy, a tab opened on the previous build still asks for
// that build's lazy chunks (e.g. SaaAnalyticsView-<oldhash>.js), which the new build no
// longer serves -> "Failed to fetch dynamically imported module". Vite dispatches
// `vite:preloadError` for exactly that failure (its preload helper wraps every dynamic
// import), so we reload the page once to pick up the new build.
//
// Loop guard: if the previous automatic reload was less than RELOAD_GUARD_MS ago, the
// failure is not a stale tab (the chunk is missing from the new build too, or the network
// is down), so the error is left to surface normally instead of reloading forever.

const STORAGE_KEY = 'crm:chunk-reload-at';
const RELOAD_GUARD_MS = 10_000;

function lastReloadAt(): number {
  try {
    return Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
  } catch {
    return 0;
  }
}

export function installChunkReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (Date.now() - lastReloadAt() < RELOAD_GUARD_MS) return; // let the error surface
    try {
      sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
      return; // no storage -> no loop guard -> do not auto-reload
    }
    event.preventDefault();
    window.location.reload();
  });
}
